<template>
    <div>
        <div class="mt-3">
            <div>
                <div class="row">
                    <div class="col-md-8 col-xl-8">
                        <a
                            class="block block-link-shadow"
                            href="javascript:void(0)"
                        >
                            <div
                                class="block-content block-content-full clearfix"
                            >
                                <div class="float-left">
                                    <img
                                        class="img-avatar img-avatar128"
                                        :src="
                                            user.avatar
                                                ? `/avatar/${user.avatar}`
                                                : '/media/avatars/avatar9.jpg'
                                        "
                                    />
                                    <div class="font-w600 mycolor">
                                        ID:
                                        {{ user.access_id }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-4"></div>
                </div>
                <!-- tab content navigation -->
                <div class="row align-items-center">
                    <div class="col">
                        <ul
                            class="nav nav-tabs nav-tabs-alt js-tabs-enabled"
                            role="tablist"
                        >
                            <li class="nav-item">
                                <a
                                    class="nav-link active"
                                    id="personal-tab"
                                    data-toggle="tab"
                                    href="#personal"
                                    role="tab"
                                    aria-controls="personal"
                                    aria-selected="true"
                                    >Personal Data</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    id="security-tab"
                                    data-toggle="tab"
                                    href="#security"
                                    role="tab"
                                    aria-controls="security"
                                    aria-selected="false"
                                    >Security</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- end of tab content navigation -->
                <!-- tab content  -->
                <div class="tab-content" id="myTabContent">
                    <div
                        class="tab-pane fade show active"
                        id="personal"
                        role="tabpanel"
                        aria-labelledby="personal-tab"
                    >
                        <personal-component :user="user" />
                    </div>
                    <div
                        class="tab-pane fade"
                        id="security"
                        role="tabpanel"
                        aria-labelledby="security-tab"
                    >
                        <security-component />
                    </div>
                </div>
                <!-- end of tab content -->

                <!-- 2fa begins -->
                <!-- <div class="mt-3">
                    <div class="row">
                        <div class="col-md-8">
                            <div>
                                <div class="block block-header">
                                    <span class="col-md-8">
                                        <strong>
                                            <h2 class="block-title">
                                                Two-Factor Authentication
                                            </h2>
                                        </strong>
                                    </span>
                                    <span class="col-md-4">
                                        <b
                                            class="text-danger"
                                            v-if="user.enable_2fa == '0'"
                                            >Disabled</b
                                        >
                                        <b class="text-earth" v-else>Enabled</b>
                                    </span>
                                </div>
                                <div class="block-content">
                                    <span>
                                        Two-factor authentication is a method
                                        for protecting your account. When it is
                                        activated you need to enter not only
                                        your password, but also a special code.
                                        This code will be sent to your email
                                        address.
                                    </span>
                                    <div class="mb-2 mt-2">
                                        <form
                                            @submit.prevent="
                                                toggle2fa(user.id, user)
                                            "
                                        >
                                            <button
                                                v-if="user.enable_2fa == '0'"
                                                type="submit"
                                                class="btn btn-info"
                                            >
                                                Enable
                                            </button>
                                            <button
                                                v-else
                                                type="submit"
                                                class="btn btn-info"
                                            >
                                                Disable
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- 2fa ends -->
            </div>
        </div>
    </div>
</template>

<script>
// import WalletComponent from "../../components/profile/wallet";
import SecurityComponent from "../../components/profile/security";
import PersonalComponent from "../../components/UserPersonal";

import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");

export default {
    components: {
        // WalletComponent,
        SecurityComponent,
        PersonalComponent
    },
    data() {
        return {
            twoFa: false,
            image1: "/media/avatars/avatar15.jpg",
            avatar: "/media/avatars/avatar9.jpg",
            user: "",
            processing: false
        };
    },
    methods: {
        sendCode(id) {
            this.processing = true;
            let data = {
                user: id
            };
            UsersRepository.verifyEmail(data)
                .then(response => {
                    this.processing = false;
                    toast.fire({
                        type: "success",
                        title: "Verification email sent"
                    });
                })
                .catch(() => {
                    toast({
                        type: "warning",
                        title: "Failed to sent verification email"
                    });
                });
        },
        toggle2fa(id, user) {
            this.twoFa = !this.twoFa;
            if (user.enable_2fa == "1") {
                let data = {
                    status: 0,
                    user: id
                };
                UsersRepository.twoFAToggle(data).then(response => {
                    Fire.$emit("Refresh");
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Disabled"
                    });
                });
            } else {
                let data = {
                    status: 1,
                    user: id
                };
                UsersRepository.twoFAToggle(data).then(response => {
                    Fire.$emit("Refresh");
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Enabled"
                    });
                });
            }
        },
        getUser() {
            UsersRepository.loggedInUser().then(response => {
                this.user = response.data;
            });
        }
    },
    created() {
        this.getUser();
        Fire.$on("Refresh", () => {
            this.getUser();
        });
    }
};
</script>
